import { render } from "./FacadeGallery.vue?vue&type=template&id=263b6f51&scoped=true&ts=true&lang=pug"
import script from "./FacadeGallery.vue?vue&type=script&lang=ts&setup=true"
export * from "./FacadeGallery.vue?vue&type=script&lang=ts&setup=true"

import "./FacadeGallery.vue?vue&type=style&index=0&id=263b6f51&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263b6f51"]])

export default __exports__